import { useLocation } from 'react-router-dom';
import { getPage } from '../content/discovery';
import '../content/discovery.css';

export default function Discovery() {
  const { pathname } = useLocation();
  const page = getPage(pathname);
  if (!page) return <main className="discovery-page"><h1>找不到此頁面</h1><a href="/clinics">查看分店資料</a></main>;
  return <div dangerouslySetInnerHTML={{ __html: page.html }} />;
}
